import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';


const ControlMonitoring = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/dispatch`}/>
            <Route path={`${match.url}/dispatch`} component={asyncComponent(() => import('./routes/Dispatch'))}/>
            <Route path={`${match.url}/tracking`} component={asyncComponent(() => import('./routes/Tracking'))}/>
            <Route path={`${match.url}/assignment`} component={asyncComponent(() => import('./routes/Assignment'))}/>
            <Route path={`${match.url}/vehicle-accident`} component={asyncComponent(() => import('./routes/VehicleAccident'))}/>
            <Route path={`${match.url}/report`} component={asyncComponent(() => import('./routes/Report'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default ControlMonitoring;


// WEBPACK FOOTER //
// ./app/routes/ControlMonitoring/index.js